import { Inject, Optional, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateLabelPipe, TranslateLabelPipeInput, TranslationLabels } from '@smooved/core';
import { SURVEY_CONFIG } from '../constants/surveys.constants';
import { SurveyConfig } from '../interfaces/survey-config.interface';
import { SurveyService } from '../services/survey.service';

@Pipe({
    name: 'translateLabel',
})
export class QuestionTranslateLabelPipe extends TranslateLabelPipe implements PipeTransform {
    protected presetInterpolation: { [key: string]: string };

    constructor(
        protected readonly translate: TranslateService,
        private readonly surveyService: SurveyService,
        @Optional() @Inject(SURVEY_CONFIG) private readonly config: SurveyConfig
    ) {
        super(translate);
    }

    transform(value: TranslationLabels, args: TranslateLabelPipeInput): string {
        this.presetInterpolation = {
            broker: this.surveyService.realEstateGroupName,
            privacyUrl: this.config.privacyUrls[this.translate.currentLang] as string,
            termsUrl: this.config.termsUrls[this.translate.currentLang] as string,
            app: this.config.applicationName as string,
        };
        return super.transform(value, args);
    }
}
